import React from "react";
import { Dropdown } from "primereact/dropdown";

export const Enfants = ({ enfants, enfant, onValueChange, disabled }) => {


    return (
        <Dropdown value={enfant} options={enfants} optionLabel="value" optionValue="key" disabled={disabled}
                  onChange={onValueChange} placeholder="Cliquez ici pour choisir" style={{maxWidth: '-webkit-fill-available'}} />
    );
}

